<template>
  <header class="the-header" :class="{ 'the-header--scrolled': isScrolled }">
    <div class="container">
      <nav class="the-header__nav">
        <router-link to="/" class="the-header__logo">
          <img src="@/assets/img/kaonR_logo.svg" alt="Kaon R" />
        </router-link>
        
        <button
          class="the-header__mobile-toggle"
          @click="toggleMobileMenu"
          :aria-expanded="isMobileMenuOpen"
          aria-label="メニューを開く"
        >
          <span class="the-header__mobile-toggle-line"></span>
          <span class="the-header__mobile-toggle-line"></span>
          <span class="the-header__mobile-toggle-line"></span>
        </button>
        
        <ul class="the-header__menu" :class="{ 'the-header__menu--open': isMobileMenuOpen }">
          <li class="the-header__menu-item">
            <router-link to="/" class="the-header__menu-link" @click="closeMobileMenu">
              TOP
            </router-link>
          </li>
          <li class="the-header__menu-item">
            <router-link to="/about" class="the-header__menu-link" @click="closeMobileMenu">
              ABOUT
            </router-link>
          </li>
          <li class="the-header__menu-item">
            <router-link to="/reserve" class="the-header__menu-link" @click="closeMobileMenu">
              RESERVE
            </router-link>
          </li>
          <li class="the-header__menu-item">
            <router-link to="/contact" class="the-header__menu-link" @click="closeMobileMenu">
              CONTACT
            </router-link>
          </li>
          <li class="the-header__menu-item the-header__menu-item--cta">
            <base-button
              variant="primary"
              size="sm"
              to="/reserve"
              @click="closeMobileMenu"
            >
              見学・レンタル予約
            </base-button>
          </li>
        </ul>
      </nav>
    </div>
  </header>
</template>

<script>
import BaseButton from '@/components/common/BaseButton.vue';

export default {
  name: 'TheHeader',
  components: {
    BaseButton
  },
  data() {
    return {
      isScrolled: false,
      isMobileMenuOpen: false
    };
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll);
  },
  beforeUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    handleScroll() {
      this.isScrolled = window.scrollY > 50;
    },
    toggleMobileMenu() {
      this.isMobileMenuOpen = !this.isMobileMenuOpen;
      document.body.style.overflow = this.isMobileMenuOpen ? 'hidden' : '';
    },
    closeMobileMenu() {
      this.isMobileMenuOpen = false;
      document.body.style.overflow = '';
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/styles/variables.scss';
@import '@/styles/mixins.scss';

.the-header {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: $z-index-fixed;
  background-color: rgba($white, 0.95);
  backdrop-filter: blur(10px);
  transition: all $transition-base;
  box-shadow: 0 1px 0 rgba($gray-200, 0.5);
  
  &--scrolled {
    background-color: rgba($white, 0.98);
    box-shadow: $shadow-md;
  }
  
  &__nav {
    @include flex-between;
    height: 70px;
    padding: 0 $spacing-md;
    
    @include media-breakpoint-up(lg) {
      height: 80px;
    }
  }
  
  &__logo {
    display: flex;
    align-items: center;
    z-index: $z-index-fixed + 1;
    
    img {
      height: 40px;
      width: auto;
      // SVGの白色をブラウンに変更
      filter: brightness(0) saturate(100%) invert(23%) sepia(20%) saturate(2118%) hue-rotate(346deg) brightness(86%) contrast(91%);
      
      @include media-breakpoint-up(lg) {
        height: 45px;
      }
    }
  }
  
  &__mobile-toggle {
    @include media-breakpoint-up(lg) {
      display: none;
    }
    
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 30px;
    height: 30px;
    padding: 0;
    background: none;
    border: none;
    cursor: pointer;
    z-index: $z-index-fixed + 1;
    
    &-line {
      display: block;
      width: 24px;
      height: 2px;
      background-color: $primary-color;
      margin: 3px 0;
      transition: all $transition-fast;
      
      .the-header__menu--open ~ .the-header__mobile-toggle & {
        &:nth-child(1) {
          transform: rotate(45deg) translate(5px, 5px);
        }
        
        &:nth-child(2) {
          opacity: 0;
        }
        
        &:nth-child(3) {
          transform: rotate(-45deg) translate(5px, -5px);
        }
      }
    }
  }
  
  &__menu {
    display: flex;
    align-items: center;
    list-style: none;
    margin: 0;
    padding: 0;
    
    @include media-breakpoint-down(lg) {
      position: fixed;
      top: 70px;
      right: 0;
      left: 0;
      bottom: 0;
      height: calc(100vh - 70px);
      flex-direction: column;
      justify-content: flex-start;
      align-items: stretch;
      background-color: $white;
      transform: translateX(100%);
      transition: transform $transition-base;
      padding: $spacing-xl;
      overflow-y: auto;
      z-index: $z-index-fixed;
      box-shadow: -5px 0 15px rgba(0, 0, 0, 0.1);
      
      &--open {
        transform: translateX(0);
      }
    }
  }
  
  &__menu-item {
    margin: 0 $spacing-xs;
    
    @include media-breakpoint-down(lg) {
      margin: $spacing-sm 0;
    }
    
    &--cta {
      margin-left: $spacing-lg;
      
      @include media-breakpoint-down(lg) {
        margin-left: 0;
        margin-top: $spacing-lg;
      }
    }
  }
  
  &__menu-link {
    display: block;
    padding: $spacing-sm $spacing-md;
    font-size: $font-size-sm;
    font-weight: 500;
    color: $gray-700;
    text-decoration: none;
    transition: color $transition-fast;
    position: relative;
    
    @include media-breakpoint-down(lg) {
      font-size: $font-size-md;
      padding: $spacing-md 0;
    }
    
    &:hover,
    &.router-link-active {
      color: $primary-color;
    }
    
    &::after {
      content: '';
      position: absolute;
      bottom: 0;
      left: 50%;
      transform: translateX(-50%) scaleX(0);
      width: calc(100% - #{$spacing-lg});
      height: 2px;
      background-color: $primary-color;
      transition: transform $transition-fast;
      
      @include media-breakpoint-down(lg) {
        display: none;
      }
    }
    
    &:hover::after,
    &.router-link-active::after {
      transform: translateX(-50%) scaleX(1);
    }
  }
}</style>